export interface QuizRouter {
  goToList(query?: string): void;
  goToDetail(id: string): void;
  goToEdit(query?: string): void;
  goToCreate(accountId: string): void;
  goToAnalytics(id: string, query?: string): void;
  goToSurveyUserAnswers(surveyId: string, attemptId: string): void;
  goBack(prevState: { pathname: string; search: string }): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuizRouter = Symbol('QuizRouter');
